<template>
  <div>
    <TopHeader code="train" />

    <section class="uc-banner240">
      <div class="con">
        <h2>师徒系统</h2>
        <div class="line"></div>
        <div class="txt">
          一对一、一对多辅导，把控徒弟培训整体进度，制定“定制化”培养方案，促进员工个人能力成长
        </div>
      </div>
    </section>

    <section class="container-fluid uc-learnMapList uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="title">选择身份</div>
          </div>
        </div>
        <div class="row list">
          <div class="col-24 col-sm-4"></div>
          <div class="col-24 col-sm-8">
            <a href="javascript:void(0);" @click="handleClickMaster">
              <div class="item">
                <img src="../../assets/images/shifu.png" alt="我是师傅" />
                <div class="more">我是师傅 <i class="el-icon-right"></i></div>
              </div>
            </a>
          </div>
          <div class="col-24 col-sm-8">
            <a href="javascript:void(0);" @click="handleClickApprentice">
              <div class="item">
                <img src="../../assets/images/tudi.png" alt="我是徒弟" />
                <div class="more">我是徒弟 <i class="el-icon-right"></i></div>
              </div>
            </a>
          </div>
          <div class="col-24 col-sm-4"></div>
          <!-- <div class="col-24 col-sm-8">
            <div class="item">
              <img src="../../assets/images/youke.png" alt="游客" />
              <div class="more">游客</div>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Shitu',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      model: {},
    };
  },
  methods: {
    handleClickMaster() {
      this.getShituMaster();
    },
    async getShituMaster() {
      const response = await this.$api.shitu.getShituMaster();
      if (response.data.code === 200) {
        if (response.data.user_is_disabled) {
          this.$message.warning('您的帐号已被禁用，无法进入！');
        } else if (response.data.master_is_disabled) {
          this.$message.warning('您的师傅身份已被取消，无法进入！');
        } else {
          this.$router.push({ name: 'ShituMasterApprentice' });
        }
      } else if (response.data.code === 404) {
        this.$message.warning('您不是师傅，无法进入！');
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleClickApprentice() {
      this.getShituRelation();
    },
    async getShituRelation() {
      const response = await this.$api.shitu.getShituRelation({ type: 0 });
      if (response.data.code === 200) {
        this.$router.push({ name: 'ShituApprenticeLog' });
      } else if (response.data.code === 404) {
        this.$router.push({ name: 'ShituWillMaster' });
      } else {
        this.$message.warning(response.data.message);
      }
    },
  },
};
</script>
